// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App_App__B2Ebb {
  font-family: "DM Sans", sans-serif;
  background-color: #f8f8f8;
  min-height: 100vh;
}

i {
  padding: 7px;
  vertical-align: middle;
}

i:hover {
  cursor: pointer;
  transition: color ease-in-out 0.3s;
}

a:hover {
  text-decoration: none;
}

hr {
    border-top: 1px solid #c1f1f7;
  }

.App_SubTitle6__xfCqL {
  background-color: #fff;
  font-weight: 700;
  color: #000;
  border: 1px solid red;
}

.App_Main__FJiSV {
  padding-top: 58px;
}

.App_Content__9goiP {
  background-color: #ffffff;
  border-radius: 2px;
  border: 1px solid #ffffff;
}

.App_Content2__dOjNY {
  background-color: #ffffff;
  border-radius: 2px;
  border: 1px solid #ffffff;
  min-height: 200px;
}

.App_FillerImage__xjEL2 {
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.App_Image__5qvtY {
  height: 200px;
  max-width: 100%;
  object-fit: contain;
}

.App_iframe__rthrJ {
  height: 120px;
  max-width: 200px;
  object-fit: cover;
}

.App_iframeFull__aB5MP {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.App_iframe2__gXiNJ {
  height: 500px;
  width: 100%;
  object-fit: contain;
}

.App_iframeIm__SR\\+Pw {
  height: 300px;
  width: 100%;
  object-fit: contain;
}

* {
  box-sizing: border-box;
}

input[type="file"] {
  display: none;
}

figure {
  text-align: center;
  display: inline-block;
}

/* scrollbar */
*::-webkit-scrollbar {
  width: 15px;
}

*::-webkit-scrollbar-track {
  background: #f1f1f1;
}

*::-webkit-scrollbar-thumb {
  background: #fff;
}

*::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/*----------------Fonts--------------------*/

.App_lato__9kKFd {
  font-family: 'Lato', sans-serif;
}

.App_playball__\\+UYIy {
  font-family: 'Playball', cursive;
}

.App_roboto__F89eO {
  font-family: 'Roboto', sans-serif;
}

.App_playfair__V-kjE {
  font-family: "Playfair Display", serif;
}

.App_MedievalSharp__MZPe6 {
  font-family: "MedievalSharp";
}

.App_MedievalSharp__MZPe6 {
  font-family: "Cinzel";
}

.App_Ultra__pdcPK {
  font-family: "Ultra";
}

/*-----line breaks------*/

hr.App_gold50__97YLI {
  border-top: 2px solid gold;
  margin: 10px auto 0px;
  width: 50%;
}

hr.App_gold70__weUZL {
  border-top: 2px solid gold;
  margin: 5px auto 5px;
  width: 70%;
}

hr.App_gold100__vqQAy {
  border-top: 2px solid gold;
  margin: 5px auto 5px;
  width: 100%;
}

hr.App_goldleft__2SK9\\+ {
  border-top: 2px solid gold;
  width: 200px;
}

hr.App_grey100__pcCvT {
  border-top: 2px solid #666666;
  margin: 5px auto 0px;
  width: 100%;
}

/*---------------------colours----------------------------*/

.App_goldbright__Ejr5N {
  color: rgb(255, 215, 0);
}

.App_golddark__nMenY {
  font-weight: 700;
  color: rgb(140, 111, 25, 99%);
}

.App_light-blue__5fQBd {
  background: rgb(232, 240, 254);
}

.App_shadow-light__b15va {
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.6);
}

.App_shadow-light1__RPZDs {
  text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.6);
}

.App_link-color1__YAVpT {
  color: rgb(143, 212, 241);
}

.App_link-color__55cj\\+ {
  color: rgb(170 231 255);
}

.App_antiquewhite__TvfzX {
  color: antiquewhite;
}

.App_blue-sea-dark__XjCvc {
  color: #0077a7;
}

.App_blue-sea__922LP {
  color: #0087BE;
}

.App_blueBack-sea__gA-D3 {
  background-color: #0077a7;
}

.App_blue-sky__jnM2M {
  color: #1AA6E4;
}

.App_aqua__D24nE {
  background-color: aquamarine;
}

.App_greentext__nHRbB {
  color: #26a69a;
}

.App_crimson__Hf1Vr {
  color: crimson;
}

.App_crimson-back__QRB9J {
  background-color: crimson;
}

.App_matt-black__UfRdg {
  background-color: #3b444b;
}

.App_border-red__FkiLh {
  border-left: 3px solid crimson;
}

.App_textmatt-black__WZ4MG {
  color: #2e5b7e;
}

.App_white-back__ur7cV {
  background-color: #F5F5F5;
}

.App_body-back__i-Kjg {
  background-color: #353839;
}

.App_offwhite__RM2nk {
  color: #F5F5F5;
}

@media screen and (max-width: 600px) {
  p {
    font-size: .75rem;
  }

  span {
    font-size: .75rem;
  }

  .App_BoldScene__Lkhg8 {
    font-size: .75rem;
  }

  h5 {
    font-size: 1rem;
  }

  h4 {
    font-size: 1rem;
  }

  h3 {
    font-size: 1rem;
  }

  h2 {
    font-size: 1rem;
  }

  h1 {
    font-size: 1.25rem;
  }

  .App_InfoBack__9xtNP p {
    font-size: .75rem;
  }

  .App_Title__NbD9D {
    font-size: .75em;
  }

  .App_Titledetail__llnmg {
    font-size: 1.25em;
  }

  .App_Titlelist__DnIcg {
    font-size: 1em;
  }

  .App_SceneTitle__rLzYu {
    font-size: 1.25em;
  }
}

/*--------------------Asset-----------------------*/

label[for="image-upload1"],
label[for="image-upload2"],
label[for="image-upload3"],
label[for="image-upload4"],
label[for="image-upload5"] {
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 200px;
  text-align: center;
  margin: 10px auto;
}`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;IACI,6BAA6B;EAC/B;;AAEF;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;;AAE5C;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yBAAyB;;AAEzB;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,WAAW;AACb;;AAEA,2DAA2D;;AAE3D;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,mDAAmD;;AAEnD;;;;;EAKE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".App {\n  font-family: \"DM Sans\", sans-serif;\n  background-color: #f8f8f8;\n  min-height: 100vh;\n}\n\ni {\n  padding: 7px;\n  vertical-align: middle;\n}\n\ni:hover {\n  cursor: pointer;\n  transition: color ease-in-out 0.3s;\n}\n\na:hover {\n  text-decoration: none;\n}\n\nhr {\n    border-top: 1px solid #c1f1f7;\n  }\n\n.SubTitle6 {\n  background-color: #fff;\n  font-weight: 700;\n  color: #000;\n  border: 1px solid red;\n}\n\n.Main {\n  padding-top: 58px;\n}\n\n.Content {\n  background-color: #ffffff;\n  border-radius: 2px;\n  border: 1px solid #ffffff;\n}\n\n.Content2 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  border: 1px solid #ffffff;\n  min-height: 200px;\n}\n\n.FillerImage {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n}\n\n.Image {\n  height: 200px;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n.iframe {\n  height: 120px;\n  max-width: 200px;\n  object-fit: cover;\n}\n\n.iframeFull {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n\n.iframe2 {\n  height: 500px;\n  width: 100%;\n  object-fit: contain;\n}\n\n.iframeIm {\n  height: 300px;\n  width: 100%;\n  object-fit: contain;\n}\n\n* {\n  box-sizing: border-box;\n}\n\ninput[type=\"file\"] {\n  display: none;\n}\n\nfigure {\n  text-align: center;\n  display: inline-block;\n}\n\n/* scrollbar */\n*::-webkit-scrollbar {\n  width: 15px;\n}\n\n*::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n*::-webkit-scrollbar-thumb {\n  background: #fff;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/*----------------Fonts--------------------*/\n\n.lato {\n  font-family: 'Lato', sans-serif;\n}\n\n.playball {\n  font-family: 'Playball', cursive;\n}\n\n.roboto {\n  font-family: 'Roboto', sans-serif;\n}\n\n.playfair {\n  font-family: \"Playfair Display\", serif;\n}\n\n.MedievalSharp {\n  font-family: \"MedievalSharp\";\n}\n\n.MedievalSharp {\n  font-family: \"Cinzel\";\n}\n\n.Ultra {\n  font-family: \"Ultra\";\n}\n\n/*-----line breaks------*/\n\nhr.gold50 {\n  border-top: 2px solid gold;\n  margin: 10px auto 0px;\n  width: 50%;\n}\n\nhr.gold70 {\n  border-top: 2px solid gold;\n  margin: 5px auto 5px;\n  width: 70%;\n}\n\nhr.gold100 {\n  border-top: 2px solid gold;\n  margin: 5px auto 5px;\n  width: 100%;\n}\n\nhr.goldleft {\n  border-top: 2px solid gold;\n  width: 200px;\n}\n\nhr.grey100 {\n  border-top: 2px solid #666666;\n  margin: 5px auto 0px;\n  width: 100%;\n}\n\n/*---------------------colours----------------------------*/\n\n.goldbright {\n  color: rgb(255, 215, 0);\n}\n\n.golddark {\n  font-weight: 700;\n  color: rgb(140, 111, 25, 99%);\n}\n\n.light-blue {\n  background: rgb(232, 240, 254);\n}\n\n.shadow-light {\n  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.6);\n}\n\n.shadow-light1 {\n  text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.6);\n}\n\n.link-color1 {\n  color: rgb(143, 212, 241);\n}\n\n.link-color {\n  color: rgb(170 231 255);\n}\n\n.antiquewhite {\n  color: antiquewhite;\n}\n\n.blue-sea-dark {\n  color: #0077a7;\n}\n\n.blue-sea {\n  color: #0087BE;\n}\n\n.blueBack-sea {\n  background-color: #0077a7;\n}\n\n.blue-sky {\n  color: #1AA6E4;\n}\n\n.aqua {\n  background-color: aquamarine;\n}\n\n.greentext {\n  color: #26a69a;\n}\n\n.crimson {\n  color: crimson;\n}\n\n.crimson-back {\n  background-color: crimson;\n}\n\n.matt-black {\n  background-color: #3b444b;\n}\n\n.border-red {\n  border-left: 3px solid crimson;\n}\n\n.textmatt-black {\n  color: #2e5b7e;\n}\n\n.white-back {\n  background-color: #F5F5F5;\n}\n\n.body-back {\n  background-color: #353839;\n}\n\n.offwhite {\n  color: #F5F5F5;\n}\n\n@media screen and (max-width: 600px) {\n  p {\n    font-size: .75rem;\n  }\n\n  span {\n    font-size: .75rem;\n  }\n\n  .BoldScene {\n    font-size: .75rem;\n  }\n\n  h5 {\n    font-size: 1rem;\n  }\n\n  h4 {\n    font-size: 1rem;\n  }\n\n  h3 {\n    font-size: 1rem;\n  }\n\n  h2 {\n    font-size: 1rem;\n  }\n\n  h1 {\n    font-size: 1.25rem;\n  }\n\n  .InfoBack p {\n    font-size: .75rem;\n  }\n\n  .Title {\n    font-size: .75em;\n  }\n\n  .Titledetail {\n    font-size: 1.25em;\n  }\n\n  .Titlelist {\n    font-size: 1em;\n  }\n\n  .SceneTitle {\n    font-size: 1.25em;\n  }\n}\n\n/*--------------------Asset-----------------------*/\n\nlabel[for=\"image-upload1\"],\nlabel[for=\"image-upload2\"],\nlabel[for=\"image-upload3\"],\nlabel[for=\"image-upload4\"],\nlabel[for=\"image-upload5\"] {\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 200px;\n  text-align: center;\n  margin: 10px auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `App_App__B2Ebb`,
	"SubTitle6": `App_SubTitle6__xfCqL`,
	"Main": `App_Main__FJiSV`,
	"Content": `App_Content__9goiP`,
	"Content2": `App_Content2__dOjNY`,
	"FillerImage": `App_FillerImage__xjEL2`,
	"Image": `App_Image__5qvtY`,
	"iframe": `App_iframe__rthrJ`,
	"iframeFull": `App_iframeFull__aB5MP`,
	"iframe2": `App_iframe2__gXiNJ`,
	"iframeIm": `App_iframeIm__SR+Pw`,
	"lato": `App_lato__9kKFd`,
	"playball": `App_playball__+UYIy`,
	"roboto": `App_roboto__F89eO`,
	"playfair": `App_playfair__V-kjE`,
	"MedievalSharp": `App_MedievalSharp__MZPe6`,
	"Ultra": `App_Ultra__pdcPK`,
	"gold50": `App_gold50__97YLI`,
	"gold70": `App_gold70__weUZL`,
	"gold100": `App_gold100__vqQAy`,
	"goldleft": `App_goldleft__2SK9+`,
	"grey100": `App_grey100__pcCvT`,
	"goldbright": `App_goldbright__Ejr5N`,
	"golddark": `App_golddark__nMenY`,
	"light-blue": `App_light-blue__5fQBd`,
	"shadow-light": `App_shadow-light__b15va`,
	"shadow-light1": `App_shadow-light1__RPZDs`,
	"link-color1": `App_link-color1__YAVpT`,
	"link-color": `App_link-color__55cj+`,
	"antiquewhite": `App_antiquewhite__TvfzX`,
	"blue-sea-dark": `App_blue-sea-dark__XjCvc`,
	"blue-sea": `App_blue-sea__922LP`,
	"blueBack-sea": `App_blueBack-sea__gA-D3`,
	"blue-sky": `App_blue-sky__jnM2M`,
	"aqua": `App_aqua__D24nE`,
	"greentext": `App_greentext__nHRbB`,
	"crimson": `App_crimson__Hf1Vr`,
	"crimson-back": `App_crimson-back__QRB9J`,
	"matt-black": `App_matt-black__UfRdg`,
	"border-red": `App_border-red__FkiLh`,
	"textmatt-black": `App_textmatt-black__WZ4MG`,
	"white-back": `App_white-back__ur7cV`,
	"body-back": `App_body-back__i-Kjg`,
	"offwhite": `App_offwhite__RM2nk`,
	"BoldScene": `App_BoldScene__Lkhg8`,
	"InfoBack": `App_InfoBack__9xtNP`,
	"Title": `App_Title__NbD9D`,
	"Titledetail": `App_Titledetail__llnmg`,
	"Titlelist": `App_Titlelist__DnIcg`,
	"SceneTitle": `App_SceneTitle__rLzYu`
};
export default ___CSS_LOADER_EXPORT___;
